export const API_URL = process.env.REACT_APP_API_URL || "";

export const FORMULA_1 = "$$y = mx + b \\tag{1}$$";
export const FORMULA_2 = "$$m = \\frac{y_2 - y_1}{x_2 - x_1} \\tag{2}$$";

export const GAS_CONVERSION_FACTOR = 26.853; // m3/GJ
